<template lang="pug">
  .b2b-page-add-parties-services
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('party_detail.title') }}
      ods-form(
        ref='projectPartiesDetailEditForm',
        :model='projectPartiesDetailEditForm',
        :rules='projectPartiesDetailEditFormRules',
        label-width='14rem',
        label-position='top',
        size='mini',
        status-icon)
        ods-row.info
          ods-col(:span='24')
            p {{ $t('party_detail.info_message') }}
        //- DATOS GENERALES DE LA EMPRESA
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.person_type.label")',
              prop='personTypeCode')
              ods-select(
                :disabled='!edition',
                v-model='projectPartiesDetailEditForm.personTypeCode',
                filterable,
                :placeholder='$t("party_detail.party_detail_edit_form.person_type.label")')
                ods-option(
                  v-for='option in optionsTypePerson',
                  :key='option.value',
                  :label='option.label',
                  :value='option.value')
            ods-form-item(
              v-if="projectPartiesDetailEditForm.personTypeCode === 'J'",
              :label='$t("party_detail.party_detail_edit_form.corporate_name")',
              prop='corporateName')
              ods-input(
                :disabled='!edition',
                v-model='projectPartiesDetailEditForm.corporateName')
            ods-form-item(
              v-if="projectPartiesDetailEditForm.personTypeCode === 'F'",
              :label='$t("party_detail.party_detail_edit_form.name")',
              prop='name')
              ods-input(
                :disabled='!edition',
                v-model='projectPartiesDetailEditForm.name')
            ods-form-item(
              v-if="projectPartiesDetailEditForm.personTypeCode === 'F'",
              :label='$t("party_detail.party_detail_edit_form.first_surname")',
              prop='firstSurname')
              ods-input(
                :disabled='!edition',
                v-model='projectPartiesDetailEditForm.firstSurname')
            ods-form-item(
              v-if="projectPartiesDetailEditForm.personTypeCode === 'F'",
              :label='$t("party_detail.party_detail_edit_form.second_surname")',
              prop='secondSurname')
              ods-input(
                :disabled='!edition',
                v-model='projectPartiesDetailEditForm.secondSurname')
            ods-form-item(
              v-if='editionLogo',
              label='Logo',
              prop='logo')
                ods-button(
                  icon='ods-icon-plus',
                  size='medium',
                  circle,
                  :disabled='!editionLogo',
                  @click.native='showUploadDialog')
                  | {{ $t('buttons.btnAdd') }}
                ods-form-item(:label="projectPartiesDetailEditForm.logo ? projectPartiesDetailEditForm.logo.name : ''" class='labelNameLogo')
                ods-button(
                  v-if='editionLogo && projectPartiesDetailEditForm.logo && projectPartiesDetailEditForm.logo.name.length > 0 ',
                  type='neutral',
                  @click='removeLogo')
                  ods-icon(name='close', size='24', class="botoneraLogo")
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.identification_tax_number")',
              prop='taxIdentificationNumber')
              ods-input(
                :disabled='true',
                v-model='taxIdentificationNumber')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.gln")',
              prop='gln')
              ods-input(
                :disabled='!edition',
                v-model='projectPartiesDetailEditForm.gln')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.enable")',
              prop='enable')
                ods-switch(
                  :disabled='!edition',
                  :active-color='primaryColor',
                  inactive-color='#D5DCE0',
                  v-model='projectPartiesDetailEditForm.enable')

        //- DATOS DIRECCION
        div.subtitle {{ $t('party_detail.subtitle.address') }}
        ods-row.info_address
          ods-col(:span='24')
            p {{ $t('party_detail.info_address') }}
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.address")',
              prop='address')
              ods-input(
                :disabled='!editionAddress && !canAdminIndra',
                v-model='projectPartiesDetailEditForm.address')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.town")',
              prop='town')
              ods-input(
                :disabled='!editionAddress && !canAdminIndra',
                v-model='projectPartiesDetailEditForm.town')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.province")',
              prop='province')
              ods-input(
                :disabled='!editionAddress && !canAdminIndra',
                v-model='projectPartiesDetailEditForm.province')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.postcode")',
              prop='postcode')
              ods-input(
                :disabled='!editionAddress && !canAdminIndra',
                v-model='projectPartiesDetailEditForm.postcode')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.country.label")',
              prop='countryName')
              ods-input(
                :disabled='true',
                v-model='projectPartiesDetailEditForm.countryName')

        //- DATOS REGISTRO MERCANTIL
        div.subtitle {{ $t('party_detail.subtitle.commercial_register') }}
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.registerOrCompaniesLocation")',
              prop='registerOrCompaniesLocation')
              ods-input(
                :disabled='!editableRegMercantil && !canAdminIndra',
                v-model='projectPartiesDetailEditForm.registerOrCompaniesLocation')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.sheet")',
              prop='sheet')
              ods-input(
                :disabled='!editableSheet && !canAdminIndra',
                v-model='projectPartiesDetailEditForm.sheet')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.book")',
              prop='book')
              ods-input(
                :disabled='!editableBook && !canAdminIndra',
                v-model='projectPartiesDetailEditForm.book')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.section")',
              prop='section')
              ods-input(
                :disabled='!editableSection && !canAdminIndra',
                v-model='projectPartiesDetailEditForm.section')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.folio")',
              prop='folio')
              ods-input(
                :disabled='!editableFolio && !canAdminIndra',
                v-model='projectPartiesDetailEditForm.folio')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.volume")',
              prop='volume')
              ods-input(
                :disabled='!editableVolume && !canAdminIndra',
                v-model='projectPartiesDetailEditForm.volume')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.additional_data")',
              prop='additionalRegistrationData')
              ods-input(
                :disabled='!editableAdditionalData && !canAdminIndra',
                v-model='projectPartiesDetailEditForm.additionalRegistrationData')

        //- ROL POR SERVICIO
        div.subtitle {{ $t('party_detail.subtitle.project_role') }}
        ods-row(type='flex')
          ods-col(:span='8')
            ods-form-item(
              ref='buyerFormItem'
              :label='$t("party_detail.party_detail_edit_form.buyer")',
              prop='buyer')
              ods-switch(
                @click.native='loadComboPartyMediaTypeParty'
                :active-color='primaryColor',
                inactive-color='#D5DCE0',
                v-model='projectPartiesDetailEditForm.buyer')
          ods-col(:span='8')
            ods-form-item(
              ref='sellerFormItem'
              :label='$t("party_detail.party_detail_edit_form.seller")',
              prop='seller')
              ods-switch(
                @click.native='loadComboPartyMediaTypeParty'
                :active-color='primaryColor',
                inactive-color='#D5DCE0',
                v-model='projectPartiesDetailEditForm.seller')
          ods-col(:span='8')
            ods-form-item(
              v-if='canAdminIndra'
              :label='$t("party_detail.party_detail_edit_form.sponsor")',
              prop='sponsor')
              ods-switch(
                @click.native='loadComboPartyMediaTypeParty'
                :active-color='primaryColor',
                inactive-color='#D5DCE0',
                v-model='projectPartiesDetailEditForm.sponsor')

    ods-row.form-actions
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='large'
            @click='saveValidationCheck("projectPartiesDetailEditForm")')
            | {{ $t('buttons.btnSaveChanges') }}
    ods-accordion.collapse(@change='')
      ods-accordion-item( name='1')
        template(slot='title')
          span {{ $t('party_detail.contact_data') }}
          span.info(v-show='!datapartymedia.length') {{ $t('party_detail.no_contact_data') }}
        ods-tooltip(:content='$t("party_detail.buttons.add_contact_data_tooltip")', placement='bottom')
          ods-button(
            icon='ods-icon-plus',
            size='small',
            circle,
            @click.native='isShowDialogPartyMedia = true')
            | {{ $t('party_detail.buttons.add_contact_data') }}

        //- Tabla de partymedia
        ods-table(
          v-if='datapartymedia.length > 0 ',
          :data='datapartymedia',
          :default-sort="{ prop: 'id', order: 'descending' }",
          style='width: 100%',
          @cell-mouse-enter='handleCellMouseEnter',
          highlight-current-row,
          size='mini',
          fit)
          ods-table-column(
            prop='mediaTypeId',
            :label='$t("party_detail.party_media_table.media_type")',
            :show-overflow-tooltip='true',
            :formatter='formatterMediaType',
            sortable='')
          ods-table-column(
            prop='value',
            :label='$t("party_detail.party_media_table.contact_data")',
            :show-overflow-tooltip='true',
            sortable='')
          ods-table-column(
            prop='typeText',
            label='Tipo de empresa',
            :formatter='formatterPartyType',
            :show-overflow-tooltip='true',
            sortable='')
          ods-table-column(
            label='',
            width='80')
            template(slot-scope='scope')
              ods-button(
                type='neutral',
                @click='removePartyMedia(scope.$index)')
                ods-icon(name='close', size='16')

    //- Dialogo Cargar logo
    ods-dialog(
      ref='dialogAddLogo',
      :title='$t("party_detail.dialog_add_logo.title")',
      :visible.sync='isShowDialogAddLogo',
      @close='handleCloseDialogAddLogo',
      width='30%')
      ods-form(
        ref='formDialogAddLogo',
        :model='formDialogAddLogo',
        :rules='rulesDialogAddLogoForm')
        ods-form-item(prop='fichero', ref='form-item-upload')
          ods-upload(
            v-model='formDialogAddLogo.fichero',
            ref='upload',
            action='#',
            :auto-upload='false',
            :on-change='onSuccessUpload',
            :on-remove='handleRemoveUpload',
            :file-list='fileList',
            :accept= 'extensionFormats.toString()')
            ods-button(
              icon='ods-icon-plus',
              size='small',
              circle)
              | {{ $t('msg_generics.file_selected') }}
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddLogo("formDialogAddLogo")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo Datos de contacto partymedia
    ods-dialog(
      ref='dialogPartyMedia',
      :title='$t("party_detail.dialog_add_contact_data.title")',
      :visible.sync='isShowDialogPartyMedia',
      @close='handleCloseDialogPartyMedia',
      width='30%')
      ods-form(
        ref='formDialogPartyMedia',
        :model='dialogPartyMediaForm',
        :rules='rulesPartyMediaForm')
          ods-form-item(
            :label='$t("party_detail.dialog_add_contact_data.media_type.label")',
            prop='mediaTypeId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPartyMediaForm.mediaTypeId',
              filterable,
              :placeholder='$t("party_detail.dialog_add_contact_data.media_type.placeholder")')
              ods-option(
                v-for='option in optionsFilterMediaType',
                :key='option.id',
                :label='$t("mediaType." + option.media)',
                :value='option.id')
          ods-form-item(
            :label='$t("party_detail.dialog_add_contact_data.party_type.label")',
            prop='rol')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPartyMediaForm.rol',
              filterable,
              :placeholder='$t("party_detail.dialog_add_contact_data.party_type.placeholder")')
              ods-option(
              v-for='option in comboTypeList',
              :key='option.code',
              :label='$t(option.description)',
              :value='option.code')
          ods-form-item(
            :label='$t("party_detail.dialog_add_contact_data.contact_data.label")',
            prop='value')
            ods-input(
              v-model.trim='dialogPartyMediaForm.value')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='addPartyMedia("formDialogPartyMedia")')
          | {{ $t('buttons.btnAdd') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-add-parties-services',
  mixins: [Utils],
  data () {
    const checkExtension = (rule, value, callback) => {
      // Obtener la extension, y cuando la tengas, haces la validacion
      if (!this.validateExtension(this.formDialogAddLogo.fichero.name)) {
        this.formDialogAddLogo.fichero = null
        this.$refs['form-item-upload'].resetField('fichero')
        this.fileList = []
        callback(new Error(this.$t('invoices.dialog_add_invoice.attachments.error_attachment_extension') + '. ' + this.$t('projects.error.wrongLogoExtension')))
      } else {
        this.fileList = []
        this.fileList.push(this.formDialogAddLogo.fichero)
        callback()
      }
    }
    const checkFileSize = (rule, value, callback) => {
      // Obtener la extension, y cuando la tengas, haces la validacion
      if (this.formDialogAddLogo.fichero && this.formDialogAddLogo.fichero.size > (100 * 1024)) {
        this.formDialogAddLogo.fichero = null
        this.$refs['form-item-upload'].resetField('fichero')
        this.fileList = []
        callback(new Error(this.$t('error.file_size.exceeded', { argumento: this.mazFileSize.toString() + ' KB' })))
      } else {
        this.fileList = []
        this.fileList.push(this.formDialogAddLogo.fichero)
        callback()
      }
    }
    return {
      // Variable flag que nos indica si los datos generales son de lectura o de escritura
      edition: null,
      editionAddress: null,
      editionLogo: null,
      editableRegMercantil: null,
      editableSheet: null,
      editableBook: null,
      editableVolume: null,
      editableSection: null,
      editableFolio: null,
      editableAdditionalData: null,
      // Para empresa existente

      // Datos seleccionados previamente
      dataParty: null,
      taxIdentificationNumber: null,
      countryId: null,
      serviceId: null,

      projectPartiesDetailEditForm: {
        // Propiedades party
        gln: null,
        personTypeCode: 'J',
        corporateName: null,
        tradeName: null,
        name: null,
        firstSurname: null,
        secondSurname: null,
        address: null,
        postcode: null,
        town: null,
        province: null,
        countryId: null,
        sheet: null,
        folio: null,
        section: null,
        volume: null,
        book: null,
        additionalRegistrationData: null,
        enable: true,
        logo: null,
        countryName: null,
        registerOrCompaniesLocation: null,
        buyer: null,
        seller: null,
        sponsor: null
      },

      // Combo tipo persona
      optionsTypePerson: [
        {
          value: 'J',
          label: this.$t('person_type.legal')
        },
        {
          value: 'F',
          label: this.$t('person_type.physical')
        }
      ],

      // Logo
      isShowDialogAddLogo: false,
      extensionFormats: ['.jpg', '.jpeg', '.png'],
      mazFileSize: 100,
      formDialogAddLogo: {
        fichero: null
      },
      fileList: [],

      rulesDialogAddLogoForm: {
        fichero: [{
          required: true,
          message: this.$t('msg_generics.file_selected'),
          trigger: 'click'
        },
        { validator: checkExtension },
        { validator: checkFileSize }
        ]
      },

      comboTypeList: [],

      // DATOS DE CONTACTO
      datapartymedia: [],
      currentRowPartyMedia: {},
      isShowDialogPartyMedia: false,
      lstNewPartyMedia: [],

      dialogPartyMediaForm: {
        mediaTypeId: null,
        rol: null,
        value: null
      },

      rulesPartyMediaForm: {
        mediaTypeId: [{
          required: true,
          message: this.$t('msg_generics.field_required')
        }],
        rol: [{
          required: true,
          message: this.$t('msg_generics.field_required')

        }],
        value: [{
          required: true,
          message: this.$t('msg_generics.field_required')
        }]
      }
    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      // Combos
      'optionsFilterMediaType',

      // Permisos
      'canAdminIndra',
      'primaryColor'
    ]),

    // Datos generales
    projectPartiesDetailEditFormRules () {
      const validaBuyerSeller = (rule, value, callback) => {
        this.$refs.buyerFormItem.clearValidate()
        this.$refs.sellerFormItem.clearValidate()
        if (!this.projectPartiesDetailEditForm.seller && !this.projectPartiesDetailEditForm.buyer) {
          callback(new Error(this.$t('auditory_detail.events.property.missing.required.projectparty.role_required')))
        } else {
          callback()
        }
      }
      return {
        corporateName: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 150,
            message: this.$t('msg_generics.max_num_character', { max: 150 }),
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        firstSurname: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        secondSurname: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        gln: [
          {
            max: 15,
            message: this.$t('msg_generics.max_num_character', { max: 15 }),
            trigger: 'change'
          }
        ],
        address: [
          {
            max: 80,
            message: this.$t('msg_generics.max_num_character', { max: 80 }),
            trigger: 'change'
          }
        ],
        postcode: [
          {
            max: 10,
            message: this.$t('msg_generics.max_num_character', { max: 10 }),
            trigger: 'blur'
          }
        ],
        town: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'blur'
          }
        ],
        province: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'blur'
          }
        ],
        sheet: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        folio: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        book: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        section: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        volume: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        additionalRegistrationData: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        registerOrCompaniesLocation: [
          {
            max: 20,
            message: this.$t('msg_generics.max_num_character', { max: 20 }),
            trigger: 'change'
          }
        ],
        buyer: [
          { validator: validaBuyerSeller, trigger: 'blur' },
          { validator: validaBuyerSeller, trigger: 'change' }
        ],
        seller: [
          { validator: validaBuyerSeller, trigger: 'blur' },
          { validator: validaBuyerSeller, trigger: 'change' }
        ]
      }
    }
  },

  methods: {
    ...mapActions([
      'getOptionsFilterMediaType',
      'getPartyMedia',
      'getPartyByTax',
      'createProjectParty',
      'getServiceDetail'

    ]),

    handleCloseDialogPartyMedia () {
      this.$refs.formDialogPartyMedia.resetFields()
    },
    validateExtension (filename) {
      return this.extensionFormats.includes('.'.concat((filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)).toLowerCase()))
    },
    // FORMATTER
    /* Formatea tipo de empresa  */
    formatterPartyType (row, column) {
      console.log(column.property)
      if (row[column.property]) return this.$t('party_type.' + row[column.property])
      else return '-'
    },

    /* Formatea el tipo de contacto */
    formatterMediaType (row, column) {
      const mediaType = this.optionsFilterMediaType.find(function (elem) {
        console.log(row[column.property] + ',' + elem.id)
        return Number(row[column.property]) === elem.id
      })
      if (mediaType) return this.$t('mediaType.' + mediaType.media)
      else return '-'
    },

    //* *Crea el combo de tipo de configuración */
    loadComboPartyMediaTypeParty () {
      console.log('loadComboPartyMediaTypeParty::init ')
      this.comboTypeList = []

      if (this.projectPartiesDetailEditForm.buyer) {
        this.comboTypeList.push({
          code: 'buyer',
          description: 'party_type.buyer'
        })
      }
      if (this.projectPartiesDetailEditForm.seller) {
        this.comboTypeList.push({ code: 'seller', description: 'party_type.seller' })
      }
      if (this.projectPartiesDetailEditForm.buyer && this.projectPartiesDetailEditForm.seller) {
        this.comboTypeList.push({ code: 'both', description: 'party_type.both' })
      }
      console.log('loadComboPartyMediaTypeParty::end ')
    },

    // Acciones del logo
    onSubmitAddLogo (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.upload_logo')
          })

          console.log('submit!!!   ', this.fileList)
          this.projectPartiesDetailEditForm.logo = this.fileList[0]
          this.isShowDialogAddLogo = false
          this.$notify({
            title: this.$t('party_detail.notify.upload_logo'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
          load.close()
        } else {
          console.log('error submit!!!!')
        }
      })
    },

    onSuccessUpload (file, fileList) {
      this.fileList = []
      this.fileList[0] = file
      this.formDialogAddLogo.fichero = file
      this.$refs.formDialogAddLogo.validateField('fichero')
    },

    handleRemoveUpload (file, fileList) {
      this.$refs['form-item-upload'].resetField('fichero')
      this.fileList = []
    },

    // Reseteo al cerrar dialogo de añadir logo
    handleCloseDialogAddLogo () {
      this.$refs.formDialogAddLogo.resetFields()
      this.fileList = []
    },
    saveValidationRequired (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.saveProjectParty(formName)
        } else {
          console.log('submitServiceDetailEditForm: ', this.projectPartiesDetailEditForm)
        }
      })
    },
    saveValidationCheck (formName) {
      if (this.edition) {
        this.saveValidationRequired(formName)
      } else {
        this.saveProjectParty(formName)
      }
    },
    /** Guarda los cambios del proyecto  */
    async saveProjectParty (formName) {
      let validOk = true
      console.log('saveProjectParty: ', this.projectPartiesDetailEditForm)
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.save_changes')
      })
      try {
        await this.createProjectParty({
          // Logo
          logo: this.projectPartiesDetailEditForm.logo,

          projectPartyData: {

            projectId: this.$route.params.projectId,
            countryId: this.countryId,
            taxIdentificationNumber: this.taxIdentificationNumber,
            seller: this.projectPartiesDetailEditForm.seller,
            buyer: this.projectPartiesDetailEditForm.buyer,
            sponsor: this.projectPartiesDetailEditForm.sponsor,
            // lista
            lstNewPartyMediaRequestTO: this.lstNewPartyMedia,

            // Party
            party: {
              gln: this.projectPartiesDetailEditForm.gln,
              personTypeCode: this.projectPartiesDetailEditForm.personTypeCode,
              corporateName: this.projectPartiesDetailEditForm.corporateName,
              tradeName: this.projectPartiesDetailEditForm.tradeName,
              name: this.projectPartiesDetailEditForm.name,
              firstSurname: this.projectPartiesDetailEditForm.firstSurname,
              secondSurname: this.projectPartiesDetailEditForm.secondSurname,
              address: this.projectPartiesDetailEditForm.address,
              postcode: this.projectPartiesDetailEditForm.postcode,
              town: this.projectPartiesDetailEditForm.town,
              province: this.projectPartiesDetailEditForm.province,
              countryId: this.projectPartiesDetailEditForm.countryId,
              sheet: this.projectPartiesDetailEditForm.sheet,
              folio: this.projectPartiesDetailEditForm.folio,
              section: this.projectPartiesDetailEditForm.section,
              volume: this.projectPartiesDetailEditForm.volume,
              book: this.projectPartiesDetailEditForm.book,
              additionalRegistrationData: this.projectPartiesDetailEditForm.additionalRegistrationData,
              enable: this.projectPartiesDetailEditForm.enable,
              registerOrCompaniesLocation: this.projectPartiesDetailEditForm.registerOrCompaniesLocation
            }
          }
        })
        if (!this.edition) {
          this.$notify({
            title: this.$t('party_detail.notify.save_changes'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } else {
          this.$notify({
            title: this.$t('party_detail.notify.created'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }
      } catch (error) {
        validOk = false
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
      // Redirigimos si todo ok
      if (validOk) {
        const response = await this.getServiceDetail(this.serviceId)
        sessionStorage.setItem('projectName', response.name)
        router.push({
          name: 'new-parties-service-country-nif',
          params: {
            projectId: this.$route.params.projectId,
            projectName: response.name
          }
        })
      }
    },
    //* *Elimina el logo del proyecto */
    removeLogo () {
      console.log('removeLogo...')
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.delete_logo')
      })
      try {
        this.projectPartiesDetailEditForm.logo = null
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    showUploadDialog (event) {
      this.isShowDialogAddLogo = true
      if (event) event.preventDefault()
    },

    selectFile (event) {
      if (event) event.preventDefault()
    },

    handleCellMouseEnter (row, column, cell, event) {
      this.currentRowPartyMedia = row
    },

    //* * Elimina un partymedia  de la lista*/
    removePartyMedia (index) {
      console.log('@@removePartyMEdia', index)
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.delete_contact_data')
      })
      try {
        // Removemos elemento
        this.lstNewPartyMedia.splice(index, 1)
        this.datapartymedia = this.lstNewPartyMedia

        this.$notify({
          title: this.$t('party_detail.notify.delete_contact_data'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log(error)
      } finally {
        load.close()
      }
    },

    //* * Agrega  un partyMedia a la lista */
    addPartyMedia (formName) {
      console.log(this.lstNewPartyMedia)
      const self = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.add_contact_data')
          })
          try {
            const mediaType = {
              mediaTypeId: self.dialogPartyMediaForm.mediaTypeId,
              value: self.dialogPartyMediaForm.value,
              buyer: self.dialogPartyMediaForm.rol === 'buyer' || self.dialogPartyMediaForm.rol === 'both',
              seller: self.dialogPartyMediaForm.rol === 'seller' || self.dialogPartyMediaForm.rol === 'both'
            }
            // Agregamos datos de contacto
            self.lstNewPartyMedia.push(mediaType)
            self.datapartymedia = self.lstNewPartyMedia
            for (let index = 0; index < this.datapartymedia.length; index++) {
              if (this.datapartymedia[index].buyer && !this.datapartymedia[index].seller) {
                this.datapartymedia[index].typeText = 'buyer'
              } else if (!this.datapartymedia[index].buyer && this.datapartymedia[index].seller) {
                this.datapartymedia[index].typeText = 'seller'
              } else if (this.datapartymedia[index].buyer && this.datapartymedia[index].seller) {
                this.datapartymedia[index].typeText = 'both'
              }
            }
          } catch (error) {
            console.log(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogPartyMedia = false
          }
        }
      })
    },

    // Carga la empresa  si existe
    async getPartyOnDatabase () {
      try {
        const response = await this.getPartyByTax({
          taxIdentificationNumber: this.taxIdentificationNumber
        })
        this.projectPartiesDetailEditForm = response
        this.projectPartiesDetailEditForm.countryName = this.$route.params.countryName
        this.edition = false
        this.editionAddress = response.editableAddress
        this.editionLogo = response.editableLogo
        this.editableRegMercantil = (!response.registerOrCompaniesLocation || response.registerOrCompaniesLocation.length === 0)
        this.editableSheet = (!response.sheet || response.sheet.length === 0)
        this.editableBook = (!response.book || response.book.length === 0)
        this.editableFolio = (!response.folio || response.folio.length === 0)
        this.editableSection = (!response.section || response.section.length === 0)
        this.editableVolume = (!response.volume || response.volume.length === 0)
        this.editableAdditionalData = (!response.additionalRegistrationData || response.additionalRegistrationData.length === 0)
      } catch (error) {
        if (error.status === 404) {
          // Si pasa por qui la empresa no existe en BD por lo tanto formulario de edicion
          this.edition = true
          this.editionAddress = true
          this.editionLogo = true
          this.editableRegMercantil = true
          this.editableSheet = true
          this.editableBook = true
          this.editableFolio = true
          this.editableSection = true
          this.editableVolume = true
          this.editableAdditionalData = true
        } else {
          this.getNotificationErrorMessage(error)
        }
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
        case 404:
        case 409:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      this.dataParty = this.$route.params
      this.taxIdentificationNumber = this.$route.params.taxIdentificationNumber
      this.countryId = this.$route.params.countryId
      this.projectPartiesDetailEditForm.countryName = this.$route.params.countryName
      this.serviceId = this.$route.params.projectId
      // Get Info
      await this.getPartyOnDatabase()
      // Tipo de contacto de un partymedia
      await this.getOptionsFilterMediaType()
      // Combo tipo de empresa
      this.loadComboPartyMediaTypeParty()
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-add-parties-services {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
      .info_address {
        padding-top: 5px;
        padding-bottom: 30px;
      }

      .title{
        size: 14px;
        line-height: 24px;
        font-weight: bold;
        margin-top: 40px;
        margin-bottom: 40px;
      }
    }

    .subtitle {
      margin-top: 40px;
      font-size: 14px;
      font-weight: 500;
      text-transform: uppercase;
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }

  .collapse{
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    .ods-button{
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
  .botoneraLogo {
    padding-bottom: rem(20);
    margin-left: rem(0);
  }
  .labelNameLogo {
    margin-top: 20px;
    vertical-align: middle;
    text-transform: initial !important;
    padding-bottom: rem(20);
    margin-left: rem(10);
    display: inline-block;
  }
}
</style>
